import styled from 'styled-components'

const FollowersSectionStyle = styled.div`
	--socialsLinkMarginTop: var(--sp13x);
	--socialIconsMarginLeft: var(--sp13x);
	--socialIconSize: var(--sp22-5x);
	--socialTextMarginLeft: var(--sp6x);

	margin-top: var(--sectionMargin);

	.linkWrap {
		margin-top: var(--socialsLinkMarginTop);
		width: fit-content;
		transform: translateY(100%);

		.followCount {
			background-image: linear-gradient(to right, var(--orange), var(--orange) 50%, var(--cream) 50%);
			background-size: 200%;
			background-position: 0%;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			transition: var(--trTime);
		}

		.linkText {
			background-image: linear-gradient(to right, var(--cream), var(--cream) 50%, var(--orange) 50%);
			background-size: 200%;
			background-position: 0%;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			transition: var(--trTime);
			margin-left: var(--socialTextMarginLeft);
		}
		@media (hover: hover) {
			&:hover {
				.followCount {
					background-position: -100%;
				}

				.linkText {
					background-position: -100%;
				}

				svg {
					transform: rotate(35deg);
					transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
				}
			}
		}

		svg {
			fill: var(--orange);
			width: var(--socialIconSize);
			height: var(--socialIconSize);
			margin-left: var(--socialIconsMarginLeft);
			transition: var(--trTime2);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--socialsLinkMarginTop: var(--sp10x);
		--socialIconsMarginLeft: var(--sp10x);
		--socialIconSize: var(--sp17-5x);
		--socialTextMarginLeft: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--socialsLinkMarginTop: var(--sp8x);
		--socialIconsMarginLeft: var(--sp8x);
		--socialIconSize: var(--sp12-5x);
		--socialTextMarginLeft: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--socialsLinkMarginTop: var(--sp7x);
		--socialIconsMarginLeft: var(--sp7x);
		--socialIconSize: var(--sp10x);
		--socialTextMarginLeft: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--socialsLinkMarginTop: var(--sp7x);
		--socialIconsMarginLeft: 0;
		--socialTextMarginLeft: var(--sp3x);

		i {
			display: none;
		}

		.followCount,
		.linkText {
			font-size: var(--sp8-5x);
		}

		.icon-youtube,
		.icon-facebook,
		.icon-instagram {
			display: none;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--socialsLinkMarginTop: var(--sp5x);
		--socialIconsMarginLeft: 0;
		--socialTextMarginLeft: var(--spSize);

		i {
			display: none;
		}

		.followCount,
		.linkText {
			font-size: var(--sp4-5x);
		}

		.icon-youtube,
		.icon-facebook,
		.icon-instagram {
			display: none;
		}
	}
`

export default FollowersSectionStyle
